import {APP_CONFIG_MAP, APP_NAME_MAP, IAppConfig} from '@/plugins/initOpenAppSDK'
import {TITLE_BAR_HEIGHT} from '@/constants'
import {IS_CLIENT, IS_DEV, IS_SERVER} from '@/constants/env'
import {parse} from 'cookie'

// 登录后或者在服务端时通过特殊的方式提供url
let loginUrl = ''
export const setLoginUrl = (config: IObject) => {
    const publicParam = Object.entries(config).reduce((pre, [key, value]) => `${pre}&${key}=${value}`, '')
    loginUrl = `?${publicParam}`
}

export const getParamsByCookie = () => {
    if (IS_CLIENT) {
        const cookie = document.cookie
        return parse(cookie)
    }
    return {}
}

/**
 * @description: 获取url上的参数转为键值对
 * @param serverUrl: 服务端渲染时手动传入url
 */
export const getSearchParams = (serverUrl = loginUrl) => {
    if (IS_SERVER && !serverUrl) {
        return {}
    }
    const searchString = serverUrl ? serverUrl.split('?')[1] : location.search.substring(1)
    const searchArray = searchString?.split('&').filter((item) => item) || []
    const searchJson: { [key: string]: string } = searchArray.reduce((prev: { [key: string]: string }, cur: string) => {
        const [key, value] = cur.split('=')
        // 当url中的参数值为undefined或null时，不赋值
        // if (value === 'undefined' || value === 'null') {
        //     return prev
        // }
        return {...prev, [key]: value}
    }, {})
    return searchJson
}

/**
 * @description: 获取公参
 * @param serverUrl: 服务端渲染时手动传入url
 */
export const getPublicParams = (serverUrl?: string) => {
    const {
        os: p_os,
        version: p_version,
        osname: p_osversion,
        p_model,
        p_model_type,
        p_channel,
        p_from,
        sid: _p_sid,
        did: _p_did,
        userId: p_uid,
        p_client,
        screen: p_resolution,
        brand: p_brand,
        network: p_network,
    } = getSearchParams(serverUrl)
    let {sid, did} = getParamsByCookie()
    let p_sid = _p_sid || sid
    let p_did = _p_did || did
    const baseHeaders: IObject = {
        p_os,
        p_version,
        p_osversion,
        p_model,
        p_model_type,
        p_channel,
        p_from,
        p_sid,
        sid: p_sid,
        p_did,
        deviceId: p_did,
        did: p_did,
        p_uid,
        p_client,
        p_resolution,
        p_brand,
        p_network,
        p_manufacturer: p_brand,
    }
    Object.keys(baseHeaders).forEach((key: string) => {
        if (baseHeaders[key] === undefined) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete baseHeaders[key]
        }
    })
    return baseHeaders
}

export interface IUaParam {
    ua: string;
    isBrowser: boolean;
    isApp: boolean;
    isLogin: boolean;
    isAndroid: boolean;
    isIOS: boolean;
    isWechat: boolean;
    appName: AppName | '';
    appNameCn: string;
    userId: string;
    sid: string;
    did: string;
    statusBarHeight: number;
    titleStatusBarHeight: number;
    isXApp: {
        isGaotuApp: boolean;
        isGongkaoApp: boolean;
        isTutuApp: boolean;
        isJingpinApp: boolean;
        isXinliApp: boolean;
        isKetangApp: boolean;
    };
    isGaotuApp: boolean;
    isGongkaoApp: boolean;
    isTutuApp: boolean;
    isJingpinApp: boolean;
    isXinliApp: boolean;
    isKetangApp: boolean;
    IS_CLIENT: boolean;
    appConfig: IAppConfig | Record<string, never>;
    [key: string]: any;
}

/**
 * @description: 获取query和环境信息
 * @param serverUrl: 服务端渲染时辅助传入的url
 * @return UaParam对象
 */
const getUaParam = (serverUrl?: string, serverUa = ''): IUaParam => {
    const ua = IS_CLIENT ? window.navigator.userAgent.toLowerCase() : serverUa.toLowerCase()
    const searchParams = getSearchParams(serverUrl)
    const {
        app: paramApp,
        userId,
        sid,
        did,
        p_client = 1,
    } = searchParams
    const appList = [
        'gaotu',
        'gongkao',
        'tutu',
        'jingpin',
        'xinli',
        'ketang',
    ]
    const isBrowser = searchParams.channel === 'browser'
    const getIsXApp = (appName: string) => ua.includes('gaotuapp-') && (new RegExp(`/${appName}(/noah)?$`).test(ua))
    const isApp: boolean = ua.includes('gaotuapp')
    const cookies = getParamsByCookie()
    const isLogin = !!sid || !!cookies.sid
    const isAndroid: boolean = ua.includes('android')
    const isIOS: boolean = ua.includes('mac os x')
    const isWechat: boolean = ua.includes('micromessenger')
    const isXApp = {
        isGaotuApp: getIsXApp('gaotu'),
        isGongkaoApp: getIsXApp('gongkao'),
        isTutuApp: getIsXApp('tutu'),
        isJingpinApp: getIsXApp('jingpin'),
        isXinliApp: getIsXApp('xinli'),
        isKetangApp: getIsXApp('ketang'),
    }
    let appName: AppName | '' = ''
    if (isApp) {
        appName = appList.includes(paramApp) ? paramApp as AppName : ''
    } else {
        appName = APP_NAME_MAP[p_client] || APP_NAME_MAP[1]
    }
    const appNameCn = APP_CONFIG_MAP[appName as AppName]?.cnName || ''
    for (const name of appList) {
        if (getIsXApp(name)) {
            appName = name as AppName
        }
    }
    const statusBarHeight = parseInt(searchParams.statusBarHeight, 10) || 0
    const titleStatusBarHeight = isApp || IS_DEV ? statusBarHeight + TITLE_BAR_HEIGHT : 0
    const appConfig = appName ? APP_CONFIG_MAP[appName] : {}
    return {
        ...searchParams,
        ...isXApp,
        ua,
        isApp,
        isLogin,
        isAndroid,
        isIOS,
        isWechat,
        appName,
        appNameCn,
        isXApp,
        userId,
        sid,
        did,
        statusBarHeight,
        titleStatusBarHeight,
        IS_CLIENT,
        isBrowser,
        appConfig,
    }
}

export default getUaParam
